import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { connectStorageEmulator, getStorage } from "firebase/storage";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD22oEmN4AiAsRi9KLTfutJG7I65NXdXIM",
  authDomain: "sen-ai-v2.firebaseapp.com",
  projectId: "sen-ai-v2",
  storageBucket: "sen-ai-v2.firebasestorage.app",
  messagingSenderId: "252303629976",
  appId: "1:252303629976:web:103e94821ca4455b1cfaed",
  measurementId: "G-82CJX14YPK"
};

const app = initializeApp(firebaseConfig);

export { app };
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "europe-west3");

// Emulators are opt-in so `npm start` matches production after `node scripts/seedTestData.js`.
// To use local emulators: REACT_APP_USE_EMULATORS=true (see .env.development.example).
export const isUsingFirebaseEmulators =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_USE_EMULATORS === "true";

const shouldUseEmulators = isUsingFirebaseEmulators;

if (shouldUseEmulators) {
  const host = process.env.REACT_APP_EMULATOR_HOST || "127.0.0.1";
  const authPort = Number(process.env.REACT_APP_AUTH_EMULATOR_PORT || 9099);
  const firestorePort = Number(process.env.REACT_APP_FIRESTORE_EMULATOR_PORT || 8080);
  const functionsPort = Number(process.env.REACT_APP_FUNCTIONS_EMULATOR_PORT || 5001);
  const storagePort = Number(process.env.REACT_APP_STORAGE_EMULATOR_PORT || 9199);

  try {
    connectAuthEmulator(auth, `http://${host}:${authPort}`, { disableWarnings: true });
  } catch (_) {
    // Ignore duplicate emulator connection during hot reload.
  }
  try {
    connectFirestoreEmulator(db, host, firestorePort);
  } catch (_) {
    // Ignore duplicate emulator connection during hot reload.
  }
  try {
    connectFunctionsEmulator(functions, host, functionsPort);
    // Some legacy calls still request default us-central1; connect that instance too.
    connectFunctionsEmulator(getFunctions(app), host, functionsPort);
  } catch (_) {
    // Ignore duplicate emulator connection during hot reload.
  }
  try {
    connectStorageEmulator(storage, host, storagePort);
  } catch (_) {
    // Ignore duplicate emulator connection during hot reload.
  }

  console.info(
    "[Firebase] Local emulators — Firestore :8080, Auth :9099. Seed with: npm run seed (from repo root, emulators running)."
  );
} else if (process.env.NODE_ENV === "development") {
  console.info("[Firebase] Cloud project sen-ai-v2 (production Firestore).");
}



